function ChatExceptions(message) {
  this.name = 'Chat Error';
  this.message = message;
  return true;
}

export default ChatExceptions;
